import React from 'react'
import { Select } from '../index'
import countries from './countries.json'
import { useSelector } from 'react-redux'
import { getAppContentLanguage } from '../../../redux/selectors'

const CountrySelector = (props) => {
  const language = useSelector((state) => getAppContentLanguage(state) )
  const countryCodes = countries[language] || countries.no

  return (
    <Select
      options={Object.entries(countryCodes).map(([code, name]) => ({
        label: name,
        value: code,
      }))}
      {...props}
      onChange={({ value }, { name }) =>
        props.onChange({ target: { name, value } })
      }
      disabled={props.disabled}
      value={
        props.value !== undefined && {
          label: countryCodes[props.value],
          value: props.value,
        }
      }
    />
  )
}

export default CountrySelector
